export default "__VITE_ASSET__C19HTzc5__"